import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EnvironmentModule } from '@epicuro-next/platform/environment';

import { MSALInterceptorConfigFactory } from './configuration';
import { AuthenticationService } from './services/authentication.service';
import { AuthStateService } from './services/auth-state.service';
import { AuthGuard } from './guards/auth.guard';
import { BroadcastService } from './services/broadcast.service';
import { AUTH_CONFIG_ANGULAR, AUTH_INTERCEPTOR_CONFIG } from './tokens';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { IAuthInterceptorConfiguration } from './models/interceptor-configuration.interface';
import { LoginService } from './services/login.service';
import { LoginPageGuard } from './guards/login-page.guard';
import { ForgotPasswordService } from './services/forgot-password.service';

@NgModule({
  imports: [EnvironmentModule],
  providers: [
    AuthenticationService,
    BroadcastService,
    AuthInterceptor,
    AuthGuard,
    LoginPageGuard,
    AuthStateService,
    LoginService,
    ForgotPasswordService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: AUTH_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
      deps: [AUTH_CONFIG_ANGULAR],
    },
  ],
})
export class AuthenticationModule {
  constructor(_: AuthStateService) {}

  public static forRoot(
    angularConfiguration: IAuthInterceptorConfiguration,
  ): ModuleWithProviders<AuthenticationModule> {
    return {
      ngModule: AuthenticationModule,
      providers: [
        {
          provide: AUTH_CONFIG_ANGULAR,
          useValue: angularConfiguration,
        },
      ],
    };
  }
}
